<div *ngIf="control && control.errors && control.touched" id="dateErrors">
  <div *ngFor="let entry of control.errors | keys" class="dateError">
    {{ 'validation.errors.' + entry | translate }}
  </div>
</div>
